import { MODES } from '@/app.config';

const GetModeIcon = {
  methods: {
    /**
     * Devuelve el nombre del icono del modo de funcionamiento
     *
     * Existen dos listados de iconos, unos de altherma y otros de aire
     * También hay un icono específico cuando se muestra en el listado de ACS
     *
     * @param {Number} mode - Modo de funcionamiento
     * @return {String} - nombre del icono del modo
     */
    GetModeIcon(mode) {
      switch (mode) {
        case MODES.AUTO:
          return 'auto';
        case MODES.COOLING:
          return 'cooling';
        case MODES.HEATING:
          return 'heating';
        case MODES.FAN:
          return 'fan';
        case MODES.DRY:
          return 'dry';
        default:
          return '';
      }
    },
  },
};

export default GetModeIcon;
